<template>
  <PageContainer :isLoading="isLoading" :error="error">
    <FetchContainer :entities="entities">
      <CityDetail />
    </FetchContainer>
  </PageContainer>
</template>

<script>
import CityDetail from './CityDetail';

import { fetchUser } from '@/mixins';
import { CITIES } from '@/constants';

export default {
  mixins: [fetchUser],

  components: { CityDetail },

  data() {
    return {
      entities: [CITIES],
    };
  },
};
</script>